const defaultBrand = {
  companyName: '国建兴华',
  systemName: 'HRM系统',
  pageTitle: '国建兴华HRM系统',
  loginTitle: '国建兴华HRM系统',
  sidebarTitle: '国建兴华HRM系统',
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.ico',
  themeColor: '#012372'
}

const runtimeBrand = window.HRM_CONFIG || {}
const brand = Object.assign({}, defaultBrand, runtimeBrand)

export function applyBrandToDocument () {
  document.title = brand.pageTitle

  const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link')
  favicon.rel = 'icon'
  favicon.href = brand.faviconUrl
  document.head.appendChild(favicon)
}

export default brand
